module.exports = __webpack_public_path__ + "static/media/rike-first-bk.9810ad34.png";